module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_RHADonors_v1.8425d356.jpg";